export default {
  Iron: 'iron',
  Steel: 'steel',
  Bronze: 'bronze',
  Silver: 'silver',
  Gold: 'gold',
  Platinum: 'platinum',
  Diamond: 'diamond',
};
